export default "__VITE_ASSET__Cvh66Xty__"